module.exports = __webpack_public_path__ + "media/images/flags/1x1/deu-9ae7fb039823ff3cd0a895517c71e76b.svg";